import React from 'react';

import {
  Home as HomeIcon,
  Notifications as NotificationsIcon,
  Password as PasswordIcon,
  PeopleAlt as PeopleAltIcon,
  Person as PersonIcon,
  Phonelink as PhonelinkIcon,
  Wysiwyg as WysiwygIcon,
} from '@mui/icons-material';

import { appRoutes } from '@clearverify/constants';

import {
  BaseLayoutLeftMenu,
  LeftMenuLogo,
  MenuItem,
  ResourcesListItem,
} from 'src/components/common';
import { useGlobalState } from 'src/hooks/shared';
import { GetInTouchModal } from 'src/modals/getInTouch';

export const LayoutLeftMenu: React.FC = () => {
  const { leftMenuDrawerState } = useGlobalState();

  return (
    <React.Fragment>
      <BaseLayoutLeftMenu
        leftMenuDrawerState={leftMenuDrawerState}
        menuItemsList={menuItems}
        myAccountItemsList={myAccountItemsList}
        footer={<ResourcesListItem />}
        rootRoute={appRoutes.inbox.index}
        logoutRoute={appRoutes.auth.logout}
        leftMenuLogo={<LeftMenuLogo showIcon={!leftMenuDrawerState.isOpened} />}
      />
      <GetInTouchModal />
    </React.Fragment>
  );
};

const menuItems: MenuItem[] = [
  {
    link: appRoutes.inbox.index,
    title: 'Home',
    icon: HomeIcon,
  },
  {
    link: appRoutes.employees.index,
    title: 'Employees',
    icon: PeopleAltIcon,
  },
  {
    link: appRoutes.reports.index,
    title: 'Reports',
    icon: WysiwygIcon,
  },
];

const myAccountItemsList: Array<MenuItem> = [
  {
    link: appRoutes.account.personalInformation,
    title: 'Personal Information',
    icon: PersonIcon,
  },
  {
    link: appRoutes.account.notifications,
    title: 'Notifications',
    icon: NotificationsIcon,
    divider: true,
  },
  {
    link: appRoutes.account.security,
    title: 'Sign-in & Security',
    icon: PasswordIcon,
  },
  {
    link: appRoutes.account.setupMfa,
    title: 'Multi-factor Authentication',
    icon: PhonelinkIcon,
  },
];
